import { useState, useEffect } from "react";
import { useCurrentUser } from "../../contexts/CurrentUserProvider";

export default (
  /** @type {string} */ featureName,
  /** @type {string} */ variableName
) => {
  const currentUser = useCurrentUser();
  const [value, setValue] = useState(/** @type {string} */ (""));

  useEffect(() => {
    if (!value) {
      const url = `/feature-variable?featureName=${featureName}&variableName=${variableName}`;
      fetch(
        url,
        {
          method: "GET",
          headers:
            currentUser && currentUser.customerId
              ? { "X-FFID": currentUser.customerId }
              : {},
        }
      )
        .then((response) => response.json())
        .then((data) => {
          console.log(`Feature flags fetched for: ${url}`, data)
          setValue((data && data.variableValue) || "");
        })
        .catch((error) => {
          console.error(`Error fetching variable for: ${url}`, error);
        });
    }
  }, []);

  return value;
};
